export const entityUuidRegexStr = '(([0-9a-z]+)-?){5}';
